/**
 * Arabic Features Translations
 * 特性翻译模块 - 阿拉伯语
 * 
 * SEO 关键词覆盖：
 * - سخان بالأشعة تحت الحمراء / تدفئة إشعاعية
 * - موفر للطاقة / ترشيد الطاقة
 * - طلاء نانو / كفاءة انبعاث
 */

import type { FeaturesTranslations } from '../../types';

export const arFeatures: FeaturesTranslations = {
  tech: {
    title: 'عنصر تدفئة مبتكر بالأشعة تحت الحمراء البعيدة',
    description: 'تُطلق سخانات JH بالأشعة تحت الحمراء أشعة تحت حمراء بعيدة تُدفئ الأشخاص والأشياء مباشرةً — تمامًا كضوء الشمس الطبيعي. توفر هذه التدفئة الإشعاعية حرارة سريعة ومتجانسة وصامتة، بدون ضوضاء أو رياح أو ضوء أو غبار، مع استهلاك طاقة أقل بنسبة تصل إلى 80٪ من أجهزة التدفئة التقليدية بالحمل الحراري.',
    aluminum: 'سبائك ألومنيوم خاصة ذات زعانف لسرعة التوصيل الحراري',
    nano: 'طلاء نانو سيراميك مسجل ببراءة اختراع لأقصى انبعاث للأشعة تحت الحمراء البعيدة',
    insulation: 'كفاءة انبعاث 86٪ للأشعة تحت الحمراء البعيدة — الأفضل في الصناعة',
    lifespan: 'تقنية تخزين حراري عاكس مسجلة ببراءة اختراع (+20٪ توفير في الطاقة)',
  },
};
